import NepaliDateLib from "nepali-date-converter";

const NepaliDate = NepaliDateLib.default || NepaliDateLib;
const MONTHS = ["Baishakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Poush", "Magh", "Falgun", "Chaitra"];

const toJs = (s) => (s instanceof Date ? s : new Date(typeof s === "string" && s.length === 10 ? s + "T00:00:00" : s));

export function toBS(s) {
  try { const d = new NepaliDate(toJs(s)); const b = d.getBS(); return { year: b.year, month: b.month, day: b.date, monthName: MONTHS[b.month] }; } catch { return null; }
}
export const fmtBS = (s, withYear = true) => { const b = toBS(s); return b ? `${b.monthName} ${b.day}${withYear ? `, ${b.year}` : ""}` : ""; };
export const fmtBSShort = (s) => { const b = toBS(s); return b ? `${b.day} ${b.monthName.slice(0, 3)}` : ""; };
export const bsMonthLabel = (s) => { const b = toBS(s); return b ? `${b.monthName} ${b.year}` : ""; };
export const bsDay = (s) => toBS(s)?.day ?? "";
